import cn from 'classnames';
import { useState } from 'react';

import { IKnmErknmFormViolation } from 'KnmErknmPackage/ErknmViolationsModule/interfaces/IKnmErknmFormViolation';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';
import { booleanSelectOptions } from 'KnmPackage/MainModule/constants/booleanSelectOptions';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import { getTitleFieldWithRedStar } from 'functions/getTitleFieldWithRedStar';

import { KnmCollapse } from '../../../KnmPackage/MainModule/components/KnmCollapse';
import styles from './ErknmViolationItem.module.scss';
import { ReactQuillEditorField } from '../../../UIPackage/MainModule/components/ReactQuillEditorField';
import { checkHasErrorInCollapseBlock } from '../../../functions/checkHasErrorInCollapseBlock';

interface IErknmActViolationInitItemProps {
  violation: IKnmErknmFormViolation;
  fieldName: string;
  formRef: IKnmFormRef | IDecisionFormRef | undefined;
  onRemove: () => void;
  isPaperless: boolean;
  id: string;
  isKnm?: boolean;
  isPm?: boolean;
  isDecision?: boolean;
}

export const ErknmActViolationInitItem = ({
  fieldName,
  violation,
  formRef,
  onRemove,
  isPaperless,
  id,
  isKnm,
  isPm,
  isDecision,
}: IErknmActViolationInitItemProps) => {
  const [isKnmCollapseOpened, setIsKnmCollapseOpened] = useState<boolean>(true);

  if (!violation.isFixedOnPlace?.value && violation.explanation) {
    // @ts-ignore
    formRef?.current.change(`${fieldName}.explanation`);
  }

  const hasError = checkHasErrorInCollapseBlock(formRef, fieldName);

  return (
    <KnmCollapse
      id={id}
      title={<span className="shared-break-word">Нарушение №{violation.number}</span>}
      bodyClassName={styles.ItemCollapseBody}
      onClose={violation.isNew ? onRemove : undefined}
      openByDefault={true}
      error={isKnmCollapseOpened && hasError}
      changeOpenedCallback={setIsKnmCollapseOpened}
    >
      <>
        <Row>
          <FieldBlock
            label={getTitleFieldWithRedStar({
              label: `Описание${!isPaperless ? ' выявленного нарушения' : ''}`,
              field: `${fieldName}.descriptionReactQuillEditor`,
              isPm,
              isKnm,
              isDecision,
            })}
            placementLabel="left"
            color={isPaperless ? 'black' : undefined}
            className={cn({ [styles.FieldBlock]: isPaperless })}
            labelSize="col-3"
            labelFontSize="small"
            type="not-space"
            id={`${id}.descriptionReactQuillEditor`}
          >
            <ReactQuillEditorField
              className={isPaperless ? '' : 'shared-row-field'}
              name={`${fieldName}.descriptionReactQuillEditor`}
              handleCustomChange={(e: string) => {
                // @ts-ignore
                formRef?.current?.change(`${fieldName}.title` as never, e);
              }}
            />
          </FieldBlock>
        </Row>
        <Row>
          <FieldBlock
            label={`${!isPaperless ? 'Нарушение н' : 'Н'}е подлежит устранению`}
            placementLabel="left"
            color={isPaperless ? 'black' : undefined}
            className={cn({ [styles.FieldBlock]: isPaperless })}
            labelSize="col-3"
            labelFontSize="small"
            type="not-space"
          >
            <FieldBlock size={!isPaperless ? 'col-3' : undefined}>
              <SelectInputField
                className={isPaperless ? '' : 'shared-row-field'}
                name={`${fieldName}.isUnfixable`}
                options={booleanSelectOptions}
                isClearable={false}
              />
            </FieldBlock>
          </FieldBlock>
        </Row>
        <Row>
          <FieldBlock
            label={`${!isPaperless ? 'Нарушение у' : 'У'}странено в ходе мероприятия`}
            placementLabel="left"
            color={isPaperless ? 'black' : undefined}
            className={cn({ [styles.FieldBlock]: isPaperless })}
            labelSize="col-3"
            labelFontSize="small"
            type="not-space"
          >
            <FieldBlock size={!isPaperless ? 'col-3' : undefined}>
              <SelectInputField
                className={isPaperless ? '' : 'shared-row-field'}
                name={`${fieldName}.isFixedOnPlace`}
                options={booleanSelectOptions}
                isClearable={false}
              />
            </FieldBlock>
          </FieldBlock>
        </Row>
        {violation.isFixedOnPlace?.value && (
          <Row>
            <FieldBlock
              label={!isPaperless ? 'Пояснение' : 'Комментарий'}
              placementLabel="left"
              color={isPaperless ? 'black' : undefined}
              className={cn({ [styles.FieldBlock]: isPaperless })}
              labelSize="col-3"
              labelFontSize="small"
              type="not-space"
            >
              <ReactQuillEditorField
                placeholder="Введите пояснение (при необходимости)"
                className={isPaperless ? '' : 'shared-row-field'}
                id={`${fieldName}.explanationReactQuillEditor`}
                name={`${fieldName}.explanationReactQuillEditor`}
                handleCustomChange={(e: string) => {
                  // @ts-ignore
                  formRef?.current?.change(`${fieldName}.explanation` as never, e);
                }}
              />
            </FieldBlock>
          </Row>
        )}
      </>
    </KnmCollapse>
  );
};
